import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import ModalAlteracoes from '../Modal-Alteracoes/Modal-Alteracoes';


class HeaderArtigo extends Component {
    constructor(props) {
        super(props);

        this.voltar = this.voltar.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.state = {
            modalAlteracoes: false,
        };
    }

    voltar() {
        if (this.props.temAlteracao) {
            this.toggleModalAlteracoes();
        } else {

            switch (this.props.match.params.periodico) {
                case "bs": this.props.history.push(`/conteudo/bs/${this.props.match.params.numEdicao}?pagina=1&limite=20`); break;
                case "tc": this.props.history.push(`/conteudo/tc/${this.props.match.params.numEdicao}?pagina=1&limite=20`); break;
                case "rd": this.props.history.push(`/conteudo/rd/${this.props.match.params.numEdicao}?pagina=1&limite=20`); break;
                case "bm": this.props.history.push(`/conteudo/bm/artigos?pagina=1&limite=10`); break;
                case "gpv": this.props.history.push(`/v2/conteudo/gpv/${this.props.match.params.numEdicao}?pagina=1&limite=20`); break;
                case "juventude-soka": this.props.history.push(`/v2/conteudo/juventude-soka/${this.props.match.params.numEdicao}?pagina=1&limite=20`); break;
                case "liga-monarca": this.props.history.push(`/v2/conteudo/liga-monarca/${this.props.match.params.numEdicao}?pagina=1&limite=20`); break;
                default: window.history.go(-1); break;
            }
        }
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    render() {
        const {
            permissaoEdicao
        } = this.props;

        return (
            <React.Fragment>
                {/* Layout desktop */}
                <div className="header-cadastro border-left border-bottom border-gray d-lg-block d-none">
                    <div className="row no-gutters py-3 align-items-center">
                        <div className="col-5 px-3">
                            {/* <button className="btn btn-outline-secondary" onClick={this.toggleMudarPermissao}>Mudar permissão</button> */}
                            {!this.props.novoArtigo ? (

                                [<p key={1} className="m-0">Status: <span className={`badge badge-${this.props.artigo.status === "Disponível" ? 'primary' : this.props.artigo.status === "Agendado" ? 'info' : 'secondary badge-opacity'}`}>{this.props.artigo.status}</span>
                                </p>,
                                <p key={2} className="m-0">Última modificação: {moment(this.props.artigo.dtModificacao).format("DD/MM/YYYY H:mm:ss")}
                                </p>]
                            ) : (
                                [<p key={1} className="m-0">Status: <span className={`badge badge-secondary badge-opacity`}>Novo artigo</span>
                                </p>,
                                    // <p className="m-0">Última modificação: {moment(this.props.artigo.dtModificacao).format("DD/MM/YYYY H:mm:ss")}
                                    // </p>
                                ]
                            )}
                        </div>
                        <div className="col-7 text-right px-3">
                            <div className="row no-gutters">
                                <div className="col-5 text-right px-3">
                                    {this.props.isLoadingAlteracoes ? (
                                        <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                    ) : (
                                        <React.Fragment>
                                            {permissaoEdicao && (
                                                <button disabled={!this.props.temAlteracao} onClick={this.props.salvarAlteracoes} className="btn btn-outline-success mx-1">{this.props.novoArtigo ? 'criar artigo' : 'salvar alterações'}</button>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>
                                <div className="col-5 text-center">
                                    {/* {this.props.artigo.status === "Disponível" ? (
                                    <button disabled={this.props.temAlteracao} onClick={() => this.props.mudaStatusArtigo("desativar")} className="btn btn-outline-danger mx-1">desativar artigo</button>
                                ) : (
                                        <button disabled={this.props.temAlteracao || this.props.novoArtigo} onClick={() => this.props.mudaStatusArtigo("publicar")} className="btn btn-outline-primary mx-1">publicar artigo</button>
                                    )} */}

                                    {this.props.artigo.status === "Disponível" && !this.props.isLoadingStatus && (
                                        <React.Fragment>
                                            {permissaoEdicao && (
                                                <button disabled={this.props.temAlteracao} onClick={() => this.props.mudaStatusArtigo("desativar")} className="btn btn-outline-danger mx-1">desativar artigo</button>
                                            )}
                                        </React.Fragment>

                                    )}
                                    {this.props.artigo.status !== "Disponível" && !this.props.isLoadingStatus && (
                                        <React.Fragment>
                                            {permissaoEdicao && (
                                                <button disabled={this.props.temAlteracao || this.props.novoArtigo} onClick={() => this.props.mudaStatusArtigo("publicar")} className="btn btn-outline-primary mx-1">publicar artigo</button>
                                            )}
                                        </React.Fragment>
                                    )}
                                    {this.props.isLoadingStatus && (
                                        <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                    )}
                                </div>
                                <div className="col-2 text-right">
                                    <button onClick={this.voltar} className="btn btn-outline-secondary mx-1">voltar</button>
                                </div>
                            </div>
                        </div>
                        {permissaoEdicao &&
                            <ModalAlteracoes
                                isOpen={this.state.modalAlteracoes}
                                toggle={this.toggleModalAlteracoes}
                            />
                        }
                    </div>
                </div>
                {/* Layout mobile */}
                <div className="header-artigo-mob d-lg-none">
                    <div className="row no-gutters">
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-3 px-4 py-4">
                                    <i className="icones fas fa-long-arrow-alt-left" onClick={this.voltar}></i>
                                </div>
                                {permissaoEdicao && (
                                    <div className="col-4 text-center py-4">
                                        {this.props.artigo.status === "Disponível" && !this.props.isLoadingStatus && (
                                            <button disabled={this.props.temAlteracao} onClick={() => this.props.mudaStatusArtigo("desativar")} className="btn btn-outline-danger">desativar</button>
                                        )}
                                        {this.props.artigo.status !== "Disponível" && !this.props.isLoadingStatus && (
                                            <button disabled={this.props.temAlteracao || this.props.novoArtigo} onClick={() => this.props.mudaStatusArtigo("publicar")} className="btn btn-outline-primary">publicar</button>
                                        )}
                                        {this.props.isLoadingStatus && (
                                            <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                        )}
                                    </div>
                                )}
                                {permissaoEdicao && (
                                    <div className="col-5 text-center py-4 px-4">
                                        {this.props.isLoadingAlteracoes ? (
                                            <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                        ) : (
                                            <button disabled={!this.props.temAlteracao} onClick={this.props.salvarAlteracoes} className="btn btn-outline-success">{this.props.novoArtigo ? 'criar' : 'salvar'}</button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <ModalAlteracoes
                            isOpen={this.state.modalAlteracoes}
                            toggle={this.toggleModalAlteracoes}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(HeaderArtigo);
